import admin from "../middleware/admin";
import auth from "../middleware/auth";
import manager from '../middleware/manager'

export const ovpRoutes = {
  path: "ovp-darba-apstaklu-sabloni",
  name: "view-ovp-job-conditions",
  meta: {
    middleware: [auth, admin]
  },
  component: () => import("@/components/ovp/OvpJobConditions"),
};

export const companyOvpRoutes = [
{  path: ":companyId/ovp-darba-apstaklu-sabloni",
  name: "view-company-ovp-job-conditions",
  meta: {
    middleware: [auth, admin]
  },
  component: () => import("@/components/ovp/CompanyOvpJobConditions"),
},
{
  path: 'ovp',
  name: 'view-company-ovp',
  meta: {
      middleware: [auth, manager]
  },
  component: () => import('@/components/ovp/CompanyOvpJobConditions')
},
];